import { logger } from '@fiverr-private/obs';

export const logWarn = (component: string, message: string, enrichment?: object) => {
    logger.warn(`[${component}] ${message}`, {
        ...enrichment,
    });
};
